import displayFlash from "partners/scripts/display_flash"
import NProgress from "nprogress"

export default function GetWithProgress(url) {
  NProgress.configure({ showSpinner: false }).start()

  return fetch(
    new Request(url, {
      method: "GET",
      cache: "no-store",
    })
  )
    .then(data => {
      data.text().then(body => eval(body))
    })
    .catch(() => {
      displayFlash("There has been an error. Please try again!", "error")
    })
    .finally(() => {
      NProgress.done(true)
    })
}
